import React, { useEffect, useState } from "react";
import { getNotification } from "../Service/Api";
import { Link } from "react-router-dom";

const Popup = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const modalData = await getNotification();
        setData(modalData || []);

        if (modalData && modalData.length > 0) {
          setShowModal(true);
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (showModal) {
      const modalElement = document.getElementById("exampleModalToggle");
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  }, [showModal]);

  return (
    <>
      {data.length > 0 && (
        <div
          className="popup modal fade"
          id="exampleModalToggle"
          aria-labelledby="exampleModalToggleLabel"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div
                id="modalH"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  {data.map((item, index) => {
                    const hasImage =
                      item?.image &&
                      Array.isArray(item.image) &&
                      item.image.length > 0;

                    const hasAttachment =
                      item?.attachments &&
                      item.attachments.length > 0;

                    return (
                      <div
                        key={index}
                        className={`carousel-item${
                          index === 0 ? " active" : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>

                        <div className="modal-body">
                          <div className="card modalcard">
                            <div className="card-body">
                              <h3>{item.title}</h3>

                              {/* ✅ Show image only if available */}
                              {hasImage && (
                                <img
                                  src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.image[0]}`}
                                  className="img-fluid"
                                  alt={item.title || "popup"}
                                />
                              )}

                              <p>{item.desc}</p>

                              <div className="clearfix"></div>

                              <div className="modal-bottom">
                                {/* ✅ Attachment button */}
                                {hasAttachment && (
                                  <Link
                                    target="_blank"
                                    to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                                    className="btn btn-primary btn-sm me-2"
                                  >
                                    Attachment
                                  </Link>
                                )}

                                {/* ✅ External URL button */}
                                {item?.url && (
                                  <Link
                                    target="_blank"
                                    to={item.url}
                                    className="btn btn-primary btn-sm"
                                  >
                                    Click Here
                                  </Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Carousel controls */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>

                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#modalH"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;